import React from 'react';
import DistributorList from '../components/Distribution/DistributorList';

const DistributionManagement = () => {
  return <DistributorList />;
};

export default DistributionManagement;
